import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ disabled, activeText, inactiveText, ...args }) {
    super(args)
    const child = this.getComponentWithVModel('el-switch')
    child.attrs = {
      ...child.attrs,
      disabled,
      activeText,
      inactiveText
    }
    this.children = [child]
  }
}
